import { getShopifyData } from "../config";

export const CreateNewAccount = async (customer) => {
  let query;
  if (customer.mobileno) {
    query = `mutation {
      customerCreate(input: {acceptsMarketing: ${customer.marketing}, firstName: "${customer.fname}", lastName: "${customer.lname}", email: "${customer.email}", password: "${customer.password}", phone: "${customer.mobileno}"}) {
        customer {
          id
          firstName
          lastName
          displayName
          email
        }
        customerUserErrors {
          code
          field
          message
        }
      }
    }
    
    `;
  } else {
    query = `mutation {
      customerCreate(input: {acceptsMarketing: ${customer.marketing}, firstName: "${customer.fname}", lastName: "${customer.lname}", email: "${customer.email}", password: "${customer.password}"}) {
        customer {
          id
          firstName
          lastName
          displayName
          email
        }
        customerUserErrors {
          code
          field
          message
        }
      }
    }
    
    `;
  }
  const response = await getShopifyData(query);
  return response.data.customerCreate;
};
